"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearAllPendingUpdates = exports.clearPendingUpdate = exports.addPendingUpdate = exports.setResizeMode = exports.toggleResizeMode = exports.clearSigningStatus = exports.setSigningStatus = exports.setSignedUserDocumentsCount = exports.setSignedUserDocuments = exports.setUnsignedUserDocumentsCount = exports.setUnsignedUserDocuments = exports.setScrollTop = exports.setCreateFormErrors = exports.setDocumentState = exports.setDocumentErrors = exports.resetChangedElement = exports.setOverview = exports.setSelectedElementID = exports.setSignedLoading = exports.setInboxLoading = exports.setOverviewLoading = exports.setDocumentsLoading = exports.setIsLoading = exports.setInitials = exports.setSignature = exports.editSelectedDocumentElementsNullId = exports.editSelectedDocumentElements = exports.popSelectedDocumentElements = exports.removeSelectedDocumentElements = exports.updateSelectedDocumentElements = exports.setSelectedDocumentElements = exports.setSelectedElement = exports.setSelectedDocument = exports.updateTemplate = exports.removeTemplate = exports.removeDocument = exports.editDocument = exports.updateDocument = exports.setOnDrag = exports.setTemplates = exports.setSelectedTemplateID = exports.setDocumentsCount = exports.setDocuments = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const _devMode = process.env.NODE_ENV !== "production";
const initialState = {
    documents: [],
    documentsCount: 0,
    templates: [],
    selectedDocument: null,
    selectedDocumentElements: [],
    selectedElement: null,
    signature: "",
    initials: "",
    isLoading: false,
    documentsLoading: false,
    overviewLoading: false,
    inboxLoading: false,
    signedLoading: false,
    selectedElementID: "",
    overview: [],
    documentErrors: [],
    onDrag: false,
    documentState: null,
    selectedTemplateID: "blank",
    createFormErrors: [],
    scrollTop: 0,
    unsignedUserDocuments: [],
    unsignedUserDocumentsCount: 0,
    signedUserDocuments: [],
    signedUserDocumentsCount: 0,
    signingStatus: null,
    resizeMode: false,
    pendingUpdates: {},
};
const slice = (0, toolkit_1.createSlice)({
    name: "document",
    initialState,
    reducers: {
        setDocuments: (state, action) => {
            state.documents = action.payload;
        },
        setDocumentsCount: (state, action) => {
            state.documentsCount = action.payload;
        },
        setTemplates: (state, action) => {
            state.templates = action.payload;
        },
        setOnDrag: (state, action) => {
            state.onDrag = action.payload;
        },
        updateDocument: (state, action) => {
            state.documents.push(action.payload);
        },
        editDocument: (state, action) => {
            state.documents = state.documents.map((x) => {
                if (x._id === action.payload._id) {
                    return Object.assign({}, action.payload);
                }
                return x;
            });
        },
        setSelectedTemplateID: (state, action) => {
            state.selectedTemplateID = action.payload;
        },
        removeDocument: (state, action) => {
            state.documents = state.documents.filter((x) => x._id !== action.payload);
        },
        removeTemplate: (state, action) => {
            state.templates = state.templates.filter((x) => x._id !== action.payload);
        },
        updateTemplate: (state, action) => {
            state.templates.push(action.payload);
        },
        setSelectedDocumentElements: (state, action) => {
            if (action.payload.length > 0) {
                const filterPage = state.selectedDocumentElements.filter((x) => x.page !== action.payload[0].page);
                state.selectedDocumentElements = [...filterPage, ...action.payload];
            }
        },
        updateSelectedDocumentElements: (state, action) => {
            state.selectedDocumentElements = [...state.selectedDocumentElements, action.payload];
        },
        removeSelectedDocumentElements: (state, action) => {
            state.selectedDocumentElements = state.selectedDocumentElements.filter((x) => x._id !== action.payload);
            // Also remove from pending updates to prevent auto-save from recreating deleted elements
            delete state.pendingUpdates[action.payload];
        },
        editSelectedDocumentElements: (state, action) => {
            state.selectedDocumentElements = [
                ...state.selectedDocumentElements.map((x) => {
                    if (x._id === action.payload._id) {
                        return Object.assign({}, action.payload);
                    }
                    return x;
                }),
            ];
        },
        editSelectedDocumentElementsNullId: (state, action) => {
            const { tempId, element } = action.payload;
            state.selectedDocumentElements = state.selectedDocumentElements.map((x) => {
                // Match by specific temp ID
                if (x._id === tempId) {
                    return Object.assign({ changed: true }, element);
                }
                return x;
            });
        },
        popSelectedDocumentElements: (state) => {
            state.selectedDocumentElements.pop();
        },
        setSelectedDocument: (state, action) => {
            state.selectedDocument = action.payload;
            state.selectedDocumentElements = [];
        },
        setSelectedElement: (state, action) => {
            state.selectedElement = action.payload;
        },
        setIsLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setDocumentsLoading: (state, action) => {
            state.documentsLoading = action.payload;
        },
        setOverviewLoading: (state, action) => {
            state.overviewLoading = action.payload;
        },
        setInboxLoading: (state, action) => {
            state.inboxLoading = action.payload;
        },
        setSignedLoading: (state, action) => {
            state.signedLoading = action.payload;
        },
        setSignature: (state, action) => {
            state.signature = action.payload;
        },
        setInitials: (state, action) => {
            state.initials = action.payload;
        },
        setSelectedElementID: (state, action) => {
            state.selectedElementID = action.payload;
        },
        setOverview: (state, action) => {
            state.overview = action.payload;
        },
        setDocumentErrors: (state, action) => {
            state.documentErrors = action.payload;
        },
        setDocumentState: (state, action) => {
            state.documentState = action.payload;
        },
        resetChangedElement: (state) => {
            state.selectedDocumentElements = state.selectedDocumentElements.map((x) => {
                return Object.assign({ changed: false }, x);
            });
        },
        setCreateFormErrors: (state, action) => {
            state.createFormErrors = action.payload;
        },
        setScrollTop: (state, action) => {
            state.scrollTop = action.payload;
        },
        setUnsignedUserDocuments: (state, action) => {
            state.unsignedUserDocuments = action.payload;
        },
        setUnsignedUserDocumentsCount: (state, action) => {
            state.unsignedUserDocumentsCount = action.payload;
        },
        setSignedUserDocuments: (state, action) => {
            state.signedUserDocuments = action.payload;
        },
        setSignedUserDocumentsCount: (state, action) => {
            state.signedUserDocumentsCount = action.payload;
        },
        setSigningStatus: (state, action) => {
            state.signingStatus = action.payload;
        },
        clearSigningStatus: (state) => {
            state.signingStatus = null;
        },
        toggleResizeMode: (state) => {
            state.resizeMode = !state.resizeMode;
        },
        setResizeMode: (state, action) => {
            state.resizeMode = action.payload;
        },
        addPendingUpdate: (state, action) => {
            const { elementId, changes } = action.payload;
            state.pendingUpdates[elementId] = {
                timestamp: Date.now(),
                changes,
            };
        },
        clearPendingUpdate: (state, action) => {
            delete state.pendingUpdates[action.payload];
        },
        clearAllPendingUpdates: (state) => {
            state.pendingUpdates = {};
        },
    },
});
_a = slice.actions, exports.setDocuments = _a.setDocuments, exports.setDocumentsCount = _a.setDocumentsCount, exports.setSelectedTemplateID = _a.setSelectedTemplateID, exports.setTemplates = _a.setTemplates, exports.setOnDrag = _a.setOnDrag, exports.updateDocument = _a.updateDocument, exports.editDocument = _a.editDocument, exports.removeDocument = _a.removeDocument, exports.removeTemplate = _a.removeTemplate, exports.updateTemplate = _a.updateTemplate, exports.setSelectedDocument = _a.setSelectedDocument, exports.setSelectedElement = _a.setSelectedElement, exports.setSelectedDocumentElements = _a.setSelectedDocumentElements, exports.updateSelectedDocumentElements = _a.updateSelectedDocumentElements, exports.removeSelectedDocumentElements = _a.removeSelectedDocumentElements, exports.popSelectedDocumentElements = _a.popSelectedDocumentElements, exports.editSelectedDocumentElements = _a.editSelectedDocumentElements, exports.editSelectedDocumentElementsNullId = _a.editSelectedDocumentElementsNullId, exports.setSignature = _a.setSignature, exports.setInitials = _a.setInitials, exports.setIsLoading = _a.setIsLoading, exports.setDocumentsLoading = _a.setDocumentsLoading, exports.setOverviewLoading = _a.setOverviewLoading, exports.setInboxLoading = _a.setInboxLoading, exports.setSignedLoading = _a.setSignedLoading, exports.setSelectedElementID = _a.setSelectedElementID, exports.setOverview = _a.setOverview, exports.resetChangedElement = _a.resetChangedElement, exports.setDocumentErrors = _a.setDocumentErrors, exports.setDocumentState = _a.setDocumentState, exports.setCreateFormErrors = _a.setCreateFormErrors, exports.setScrollTop = _a.setScrollTop, exports.setUnsignedUserDocuments = _a.setUnsignedUserDocuments, exports.setUnsignedUserDocumentsCount = _a.setUnsignedUserDocumentsCount, exports.setSignedUserDocuments = _a.setSignedUserDocuments, exports.setSignedUserDocumentsCount = _a.setSignedUserDocumentsCount, exports.setSigningStatus = _a.setSigningStatus, exports.clearSigningStatus = _a.clearSigningStatus, exports.toggleResizeMode = _a.toggleResizeMode, exports.setResizeMode = _a.setResizeMode, exports.addPendingUpdate = _a.addPendingUpdate, exports.clearPendingUpdate = _a.clearPendingUpdate, exports.clearAllPendingUpdates = _a.clearAllPendingUpdates;
exports.default = slice.reducer;
